import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toast, Toaster } from "@opala-ds/react";
import { createContext, useCallback, useContext, useMemo } from "react";
const toastStyles = {
    success: {
        background: "#16a34a",
        color: "#fff",
    },
    error: {
        background: "#dc2626",
        color: "#fff",
    },
    warning: {
        background: "#f59e0b",
        color: "#000",
    },
    info: {
        background: "#2563eb",
        color: "#fff",
    },
};
const ToastContext = createContext(undefined);
export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within ToastProvider");
    }
    return context;
};
export const ToastProvider = ({ children }) => {
    const showToast = useCallback((message, variant = "info") => {
        toast(message, {
            style: toastStyles[variant],
        });
    }, []);
    const value = useMemo(() => ({ showToast }), [showToast]);
    return (_jsxs(ToastContext.Provider, { value: value, children: [children, _jsx(Toaster, { className: "toaster group text-lg", dir: "auto", duration: 4000, position: "bottom-right", richColors: true, toastOptions: { className: "bg-red-600 text-white text-md" }, swipeDirections: ["left", "right"], theme: "light" })] }));
};
